<template>
  <div>
    <div class="row">
      <div class="col-12 text-center mb-3">
        <label>Entrega de información base</label>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', currentComponentValues.Solicitantes ? 'completado' : '']">
          <span class="number">
            <i v-if="currentComponentValues.Solicitantes" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="currentComponentBody === 'Solicitantes' ? 'active-menu' : 'text-menu'" @click="selected('Solicitantes')">
          Solicitantes
        </a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', currentComponentValues.Ubicacion ? 'completado' : '']">
          <span class="number">
            <i v-if="currentComponentValues.Ubicacion" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="currentComponentBody === 'Ubicacion' ? 'active-menu' : 'text-menu'" @click="selected('Ubicacion')">Ubicación</a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', currentComponentValues.Documentos ? 'completado' : '']">
          <span class="number">
            <i v-if="currentComponentValues.Documentos" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="currentComponentBody === 'Documentos' ? 'active-menu' : 'text-menu'" @click="selected('Documentos')">
          Documentos
        </a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', currentComponentValues.Cotizacion ? 'completado' : '']">
          <span class="number">
            <i v-if="currentComponentValues.Cotizacion" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="currentComponentBody === 'Cotizacion' ? 'active-menu' : 'text-menu'" @click="selected('Cotizacion')">
          Cotización
        </a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', currentComponentValues.Pago ? 'completado' : '']">
            <span class="number">
              <i v-if="currentComponentValues.Pago" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="currentComponentBody === 'Pago' ? 'active-menu' : 'text-menu'" @click="selected('Pago')">Pago</a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 justify-content-center">
        <div class="text-center">
          <label>Complementa la información</label>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer" v-if="envio">
        <div class="ml-3">
          <div :class="['circle', currentComponentValues.EnvioDomicilio ? 'completado' : '']">
            <span class="number">
              <i v-if="currentComponentValues.EnvioDomicilio" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="currentComponentBody === 'EnvioDomicilio' ? 'active-menu' : 'text-menu'" @click="selected('EnvioDomicilio')">
            Envío a Domicilio
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', currentComponentValues.ComplementaNotificado ? 'completado' : '']">
            <span class="number">
              <i v-if="currentComponentValues.ComplementaNotificado" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="currentComponentBody === 'ComplementaNotificado' ? 'active-menu' : 'text-menu'"
            @click="selected('ComplementaNotificado')"
          >
            Notificado
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', currentComponentValues.ComplementaSolicitantes ? 'completado' : '']">
            <span class="number">
              <i v-if="currentComponentValues.ComplementaSolicitantes" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="currentComponentBody === 'ComplementaSolicitantes' ? 'active-menu' : 'text-menu'"
            @click="selected('ComplementaSolicitantes')"
          >
            Solicitantes
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', currentComponentValues.EntregaDocumentos ? 'completado' : '']">
            <span class="number">
              <i v-if="currentComponentValues.EntregaDocumentos" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="currentComponentBody === 'EntregaDocumentos' ? 'active-menu' : 'text-menu'"
            @click="selected('EntregaDocumentos')"
          >
            Entrega de documentos
          </a>
        </div>
      </div>
  </div>
</template>
<script>
import { computed } from 'vue';
import { useNotificacionStore } from "@/stores";

export default {
  name: "TreeNotificaciones",

  setup() {
    const notificacionStore = useNotificacionStore();

    const currentComponentBody = computed(() => notificacionStore.currentComponentBody);
    const envio = computed(() => notificacionStore.envio_domicilio);

    return {
      currentComponentValues: notificacionStore.currentComponentValues,
      currentComponentBody,
      envio
    };
  },

  methods: {
    selected(node) {
      this.$emit("node", node);
    },
  },
};
</script>

<style scoped>
.completado {
  background-color: yellowgreen !important;
}

.number {
  font-size: 11px;
  color: white;
}
</style>
